import { render, staticRenderFns } from "./BbeeAccesosDirectosCRM.vue?vue&type=template&id=2a13b4b0"
import script from "./BbeeAccesosDirectosCRM.vue?vue&type=script&lang=js"
export * from "./BbeeAccesosDirectosCRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports